"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/List/EmptyRoomsList.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _NewRoom = require('web/screens/VideoRooms/Modals/NewRoom'); var _NewRoom2 = _interopRequireDefault(_NewRoom);

const EmptyRoomsList = () => {
  const [isNewRoomModalOpen, setIsNewRoomModalOpen] = _react.useState.call(void 0, false)
  const openNewRoomModal = _react.useCallback.call(void 0, () => setIsNewRoomModalOpen(true), [])
  const closeNewRoomModal = _react.useCallback.call(void 0, () => setIsNewRoomModalOpen(false), [])

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "blmh-desktop-hide meeting-rooms--empty-list" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 11}}
        , _react2.default.createElement('div', { className: "meeting-rooms--empty-list--wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}}
          , _react2.default.createElement('img', {
            className: "meeting-rooms--empty-list--icon",
            src: "/assets/icons/video/camera-lightgrey.svg",
            alt: "+", __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}
          )
          , _react2.default.createElement('h3', { className: "meeting-rooms--empty-list--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}, "No Meeting Rooms"  )
          , _react2.default.createElement('span', { className: "meeting-rooms--empty-list--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}, "Meeting rooms let you jump on a video call with coworkers and patients."

          )
          , _react2.default.createElement('a', {
            className: "meeting--btn meeting-rooms--empty-list--button" ,
            onClick: openNewRoomModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
, "Create meeting room"

          )
        )
      )
      , _react2.default.createElement('span', { className: "blmh-mobile-hide meeting-rooms--empty-list-note" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}, "No meetings found."

      )
      , _react2.default.createElement(_NewRoom2.default, {
        isMobile: true,
        isOpen: isNewRoomModalOpen,
        onClose: closeNewRoomModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
      )
    )
  )
}

exports. default = EmptyRoomsList
